import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { User } from 'app/main/user/user.model';
import { StatutNotificationEnum } from './statut.enum';

@Entity({ modelName: "Notification", uriName: "notifications" })
export class Notification {
	@Key id: number;
	name: string;
	rowVersion: number;
	actionRaise: string;
	critique: boolean;
	date: Date;
	repeatability: string;
	source: string;
	idSource: number;
	statut: StatutNotificationEnum;
	type: string;
	nextNotification: Notification;
	destinataires: User[];
	close: boolean;
	description: string;

}


